<div class="row faq section">
    <div class="col-12 px-4">
      <div [id]="id" class="event__faq">
        <div class="section__faq mb-4 mb-xl-5" [innerHTML]="block.blockTitle"></div>
        <ng-container *ngFor="let question of block.faq">
          <mat-expansion-panel style="height: unset; box-shadow: none; border-radius: 0; margin-bottom: 10px">
            <mat-expansion-panel-header style="height: unset;">
              <mat-panel-description>
                <div class="question" [innerHTML]="question.question"></div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="answer" [innerHTML]="question.answer"></div>
          </mat-expansion-panel>
        </ng-container>
      </div>
    </div>
  </div>